import { render, staticRenderFns } from "./WebShop.vue?vue&type=template&id=3a5ad492&"
import script from "./WebShop.vue?vue&type=script&lang=js&"
export * from "./WebShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports